// extracted by mini-css-extract-plugin
export default {"Sidebar":"Sidebar_Sidebar__OD4TI","Sidebar__switch":"Sidebar_Sidebar__switch__oVuBy","Sidebar__container":"Sidebar_Sidebar__container__Bdrfj"};